define('viewModels/privileged/composer/forms/formEditor/Predicate',[
    'lib/lodash4',
    'lib/knockout',
    'viewModels/ViewModel',
    'services/loggingService'
], function (
    _,
    ko,
    ViewModel,
    loggingService
) {
    'use strict';

    function buildPredicatePath(question, answer) {
        if (question) {
            var answerOptions = question.answerOptions();
            if (answer && answer.id && answerOptions) {
                var answerIndex = _.findIndex(answerOptions, {'id': answer.id});
                if (answerIndex !== -1) {
                    return "/form/questionGroup/" + question.questionGroupIndex() +
                        "/question/" + question.index() +
                        "/answer/" + answerIndex;
                }
            }
        }

        return null;
    }

    function getQuestionAndAnswerFromPath(predicatePath, questionOptions, defaultQuestionGroupIndex) {
        var selectedQuestion;
        var selectedAnswer;

        if (predicatePath) {
            var pathIndices = [];
            var predicateParts = predicatePath.split('\/');
            for (var i=0; i < predicateParts.length; i++) {
                var pathIndex = parseInt(predicateParts[i]);
                if (!isNaN(pathIndex)) {
                    pathIndices.push(pathIndex);
                }
            }

            var answerIndex = pathIndices.pop();
            var questionIndex = pathIndices.pop();
            var questionGroupIndex = pathIndices.pop(); // undefined if array is empty at this point

            if (!_.isInteger(questionGroupIndex)) {
                 questionGroupIndex = defaultQuestionGroupIndex;
            }

            // Could probably optimize to get rid of these loops by building a map and re-using it, but
            // preferring the simplicity of this over the map for now.
            if (_.isInteger(questionIndex) && _.isInteger(questionGroupIndex)) {
                selectedQuestion = _.find(questionOptions(), function (question) {
                    return question.index() === questionIndex && question.questionGroupIndex() === questionGroupIndex;
                });
            }

            if (selectedQuestion && _.isInteger(answerIndex) && selectedQuestion.answerOptions().length > answerIndex) {
                selectedAnswer = selectedQuestion.answerOptions()[answerIndex];
            } else {
                loggingService.error("Could not select question and answer for predicate", { predicatePath: predicatePath });
            }
        }

        return {
            selectedQuestion: selectedQuestion,
            selectedAnswer: selectedAnswer
        };
    }

    var PredicateViewModel = ViewModel.extend(function predicateVM_init(predicatePath, predicatesList, updatePredicatePath, questionMap, questionGroupIndex, getQuestionOptions) {
        var self = this;

        self.selectedQuestion = ko.observable();
        self.selectedAnswer = ko.observable();

        var questionAndAnswer = getQuestionAndAnswerFromPath(predicatePath, questionMap, questionGroupIndex);
        self.selectedQuestion(questionAndAnswer.selectedQuestion);
        if (questionAndAnswer.selectedQuestion) {
            self.selectedAnswer(questionAndAnswer.selectedAnswer);
        }

        var getAnswerOptionsForQuestion = function (question) {
            return _.filter(question.answerOptions(), function (answer) {
                if (self.selectedAnswer() && answer.id === self.selectedAnswer().id) {
                    return true;
                } else {
                    var path = buildPredicatePath(question, answer);
                    return !_.includes(predicatesList(), path);
                }
            });
        };

        var getRemainingQuestionOptions = function() {
            // Filter out questions for which all options have already been picked
            return _.filter(getQuestionOptions(), function (questionOption) {
                return getAnswerOptionsForQuestion(questionOption).length > 0;
            });
        };

        self.getQuestionOptions = ko.observableArray(getRemainingQuestionOptions());
        self.multiSubscribe([getQuestionOptions, predicatesList], function () {
            self.getQuestionOptions(getRemainingQuestionOptions());
        });

        if (self.getQuestionOptions().length === 0) {
            loggingService.error("PredicateViewModel constructed without any valid predicate options.");
        }

        if (!self.selectedQuestion()) {
            self.selectedQuestion(self.getQuestionOptions()[0]);
        }

        self.getAnswerOptions = ko.observableArray(getAnswerOptionsForQuestion(self.selectedQuestion()));
        self.multiSubscribe([self.selectedQuestion, predicatesList], function (newSelectedQuestion) {
            self.getAnswerOptions(getAnswerOptionsForQuestion(newSelectedQuestion));
        });

        if (!self.selectedAnswer()) {
            self.selectedAnswer(self.getAnswerOptions()[0]);
        }

        var rebuildPredicatePath = function (newQuestion, newAnswer) {
            var newPredicatePath = buildPredicatePath(newQuestion, newAnswer);
            if (newPredicatePath && newPredicatePath !== self.predicatePath()) {
                self.predicatePath(newPredicatePath);
                updatePredicatePath(self);
            }
        };

        self.predicatePath = ko.observable();
        self.computed(function () {
            if (self.selectedQuestion()) {
                ko.unwrap(self.selectedQuestion().index);
                ko.unwrap(self.selectedQuestion().questionGroupIndex);
            }
            if (self.selectedAnswer()) {
                ko.unwrap(self.selectedAnswer().index);
            }
            rebuildPredicatePath(self.selectedQuestion(), self.selectedAnswer());
        });

        self.getQuestionText = function(question) {
            return ko.unwrap(question.text) || ko.i18n.renderString("composer.evaluations.noQuestionText");
        };

        self.getAnswerText = function(question) {
            return ko.unwrap(question.text) || ko.i18n.renderString("composer.evaluations.noQuestionText");
        };

    }, true); //flag indicates that the model should be passed to the parent constructor

    PredicateViewModel.buildPredicatePath = buildPredicatePath;

    return PredicateViewModel;
});

